import { AfterViewInit, Component, DoCheck, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormGroup, FormBuilder, Form } from "@angular/forms";
import { Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { ServiceAreasService } from "../../../../services/core/service-areas-service/service-areas.service";
import { sweetAlert } from "src/app/utils/swal";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
@UntilDestroy()

@Component({
  selector: 'app-service-areas-add',
  templateUrl: './service-areas-add.component.html',
  styleUrls: ['./service-areas-add.component.css']
})
export class ServiceAreasAddComponent implements OnInit {
  serviceAreaForm!: FormGroup;
  zipCodeForm!: FormGroup
  submitted = false;
  zipCodeSubmitted = false;
  userId = null;
  serviceAreaId:any;
  zipCodeArray = [];

    // Edit Modal Inputs and Outputs
    @Input() serviceAreas: any;
    @Input() source: any;
    @Output() onSaveServiceAreas = new EventEmitter<string>();
    @Output() onCloseModal = new EventEmitter<string>();
    // Edit Modal Inputs and Outputs End

  constructor(
    private serviceArea: ServiceAreasService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router
  ) { }

  ngOnInit() {
    if (this.source === 'modal' && this.serviceAreas) {
      this.serviceAreaId = this.serviceAreas.id;
      this.getServiceAreabyId();
    } else {
      this.activatedRoute.params.pipe(untilDestroyed(this)).subscribe((param) => {
        if (param && param['id']) {
          this.serviceAreaId = param['id'];
          this.getServiceAreabyId();
        }
      });
    }

    this.serviceAreaForm = this.fb.group({
      title: ["", Validators.required],
      description: ["", Validators.required],
      isActive: [true, Validators.required],
      zipCodes: [[]]
    });

    this.zipCodeForm = this.fb.group({
      zipCode:['',Validators.required]
    })

  }

  addZipCode() {
    this.submitted = true;
    this.zipCodeSubmitted = true;
    if (this.zipCodeForm.invalid) {
      return;
    }
    for(let item of this.zipCodeArray){
      this.serviceAreaForm.value.zipCodes.push(item);
    }
    this.zipCodeArray= [];
    this.zipCodeForm.reset();
    this.zipCodeSubmitted = false;
    this.submitted = false;
  }

  removeZipCode(index:any) {
    const z1 = this.serviceAreaForm.value.zipCodes;
    z1.splice(index, 1);
    this.serviceAreaForm.patchValue({
      zipCodes: z1
    });
  }

  getServiceAreabyId(){
    this.serviceArea.getById(this.serviceAreaId)
    .pipe(untilDestroyed(this)).subscribe(
      (data) => {
        if (data) {
          this.serviceAreaForm.patchValue(data)
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
    );
  }

  onInputChange(event: any) {
    const inputValue = event.target.value;
    if (inputValue) {
      const values = inputValue.split(',');
       this.zipCodeArray = values.map((value:any) => value.trim());
    }
  }


  saveStaff() {
    this.submitted = true;
    if (this.serviceAreaForm.invalid || this.serviceAreaForm.value.zipCodes.length === 0) {
      this.zipCodeSubmitted = true;
      return;
    } else {
      let payload = this.serviceAreaForm.value;
      this.serviceArea.save(payload,this.serviceAreaId)
      .pipe(untilDestroyed(this)).subscribe(
        (data) => {
          if (data) {
            if (this.source === 'modal') {
              this.onSaveServiceAreas.emit(data);
            } else {
              this.router.navigateByUrl("configurations/service-areas");

            }
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
    }
  }

  get form() {
    return this.serviceAreaForm.controls;
  }
  get formControl(){
    return this.zipCodeForm.controls;
  }


ngOnDestroy(): void {
}

}
